// @givmo/social — Social's sidebar rows (SMM-WEB1; the shell's mechanic 5: a module declares its
// rows, the shell draws the frame, Team and the Organization section).

import type { LucideLikeIcon } from '@givmo/design-system';
import type { ModuleNav } from '@givmo/org-console';
import { AtSign, Megaphone } from 'lucide-react';
import { SOCIAL_READ_PERMISSION, SOCIAL_ROUTE, SOCIAL_ROUTES, SOCIAL_SLUG } from './social-routes';

/**
 * Two rows under one section: Posts (the module's root, lit beneath it for a post, a new post and
 * the connect return) and Accounts. Both on the module's read string, the one every page needs.
 */
export const SOCIAL_NAV: ModuleNav<LucideLikeIcon> = {
  slug: SOCIAL_SLUG,
  sections: [
    {
      id: SOCIAL_SLUG,
      label: 'Social',
      rows: [
        {
          id: SOCIAL_SLUG,
          label: 'Posts',
          icon: Megaphone,
          destination: { kind: 'module', slug: SOCIAL_SLUG },
          requires: SOCIAL_READ_PERMISSION,
          alsoActiveUnder: [`${SOCIAL_ROUTE}/posts`, SOCIAL_ROUTES.compose],
        },
        {
          id: 'social-accounts',
          label: 'Accounts',
          icon: AtSign,
          destination: { kind: 'page', path: SOCIAL_ROUTES.accounts },
          requires: SOCIAL_READ_PERMISSION,
          alsoActiveUnder: [SOCIAL_ROUTES.connected],
        },
      ],
    },
  ],
  includeOrganizationSection: true,
};
